import * as History from 'history'
import moment from 'moment'
import { parse } from 'query-string'

export const dateFromUrlParams = (location: History.Location = null): moment.Moment => {
  if (location) {
    const params = parse(location.search)
    return moment(params.selectedDate ? params.selectedDate : new Date())
  } else {
    return moment(new Date())
  }
}



// WEBPACK FOOTER //
// ./src/components/date-selector/utils.ts